import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridHideLateEvening';
const DEFAULT_VALUE = false;

export const useHideLateEvening = () => {
	const [hideLateEvening, setHideLateEvening] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { hideLateEvening, setHideLateEvening };
};
